import BackendContext, { withBackend } from './context';
import Backend from './Backend';

export default Backend;

export { BackendContext, withBackend };
